import { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import Buttons from "../components/Buttons";
import { mainTable } from "../css/Common";
import FileUpload from "../ReusableComponents/FileUpload";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  JSONAPI,
} from "../services/APIConnection";
import toast from "react-hot-toast";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import GridPage from "../components/GridPage";
import { documentRepositoryHeader } from "../components/HeaderAttribute";
import AddScreenTitle from "../components/AddScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import DocumentRepositoryPopup from "../popup-containers/DocumentRepositoryPopp";
import NoOfReferencesPopup from "../popup-containers/NoOfReferencesPopup";
import DocumentRepositroyFilePopup from "../popup-containers/DocumentRepositroyFilePopup";

const DocumentRepository = () => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const [rowIndex, setRowIndex] = useState(null);

  const [documentRepositoryFields, setDocumentRepositoryFields] = useState({
    date: new Date().toISOString().split("T")[0],
    documentName: "",
    bank: "",
    bankBranch: "",
    amount: "",
    referenceNumber: "",
    showImage: null,
    ImageSize: "",
  });
  const [documentRepositoryFieldsError, setDocumentRepositoryFieldsError] =
    useState({
      dateError: "",
      paymentMethodError: "",
      documentNameError: "",
      bankError: "",
      bankBranchError: "",
      amountError: "",
      referenceNumberError: "",
      showImageError: null,
    });
  const [popUpSubmit, setPopUpSubmit] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [noOfReferencesPopUpOpen, setNoOfReferencesPopUpOpen] = useState(false);

  const [filePopUp, setFilePopUp] = useState(false);
  const [fileName, setFileName] = useState("");
  const [filePopUpOpen, setFilePopUpOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [headerDetails, setHeaderDetails] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [imageSize, setImageSize] = useState(0);
  const [documentRepositoryId, setDocumentRepositoryId] = useState(0);
  const [bindDocumentRepositoryData, setBindDocumentRepositoryData] = useState(
    []
  );

  const [documentRepositoryPopupData, setBindDocumentRepositoryPopupData] =
    useState([]);

  const [documentRepositoryData, setDocumentRepositoryData] = useState({});

  const [noOfReferencesDatas, setNoOfReferencesDatas] = useState([]);
  const [noOfReferences, setNoOfReferences] = useState(0);

  const [fileClear, setFileClear] = useState(false);

  useEffect(() => {
    bindDocumentRepository();
  }, []);

  const bindDocumentRepository = async () => {
    try {
      setIsLoading(true);

      const partnerId = sessionStorage.getItem("partnerId");
      const payload = {
        MstPartnerId:
          partnerId && partnerId !== "null" ? parseInt(partnerId, 10) : 0,
      };

      // Run both API calls in parallel
      const [docRepoRes, systemSettingsRes] = await Promise.all([
        BindPostAPI(payload, "DocumentRepositoryAPI/BindDocumentRepository"),
        BindAPI("SystemSettingsAPI/BindSystemSettings"),
      ]);

      // Handle document repository data
      const tableData = docRepoRes?.data?.Table || [];
      const table1Data = docRepoRes?.data?.Table1 || [];
      if (tableData.length > 0) {
        setVisibleTable(true);
        setVisibleAdd(false);
      } else {
        showAdd();
      }
      setBindDocumentRepositoryData(tableData);
      setBindDocumentRepositoryPopupData(table1Data);

      // Handle image size from system settings
      const systemSettings = systemSettingsRes?.data?.Table || [];
      if (systemSettings.length > 0) {
        setImageSize(systemSettings[0].SizeForFileAttachment);
      }
    } catch (error) {
      console.error("Error in bindDocumentRepository:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const createdBy = sessionStorage.getItem("createdBy");
  const partnerId = sessionStorage.getItem("partnerId");

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    if (flag === 1) {
      const isFormError = {
        ...documentRepositoryFieldsError,

        documentNameError: documentRepositoryFields.documentName?.trim()
          ? ""
          : "Enter Document Name",

        showImageError: documentRepositoryFields.showImage
          ? ""
          : "Please select files to upload",
      };

      setDocumentRepositoryFieldsError(isFormError);

      const isFormValid = Object.values(isFormError).every(
        (error) => error === ""
      );

      if (isFormValid) {
        const payload = {
          documentRepositoryId: documentRepositoryId ? documentRepositoryId : 0,
          mstPartnerId: parseInt(partnerId, 10),
          date: documentRepositoryFields.date,
          documentName: documentRepositoryFields.documentName,
          attachment: documentRepositoryFields.showImage,
          documentSize: documentRepositoryFields.ImageSize.toString(),
          createdBy: parseInt(createdBy, 10),
          flag: flag,
        };

        const response = await IUDAPI(
          payload,
          "DocumentRepositoryAPI/IUDDocumentRepository"
        );
        if (flag === 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Document Repository added successfully 👍", {
              duration: 4000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          } else {
            toast.error("Failed to add Document Repository 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
        setIsOpen(true);
      }
    } else {
      const data = {
        documentRepositoryId: documentRepositoryId,
        mstPartnerId: parseInt(partnerId, 10),
        attachment: documentRepositoryFields.showImage,
        createdBy: parseInt(createdBy, 10),
        flag: flag,
      };
      const response = await IUDAPI(
        data,
        "DocumentRepositoryAPI/IUDDocumentRepository"
      );
      const result = response.data.Table[0].Result;
      if (flag === 3 && result === "D") {
        await JSONAPI(
          { FileUrl: documentRepositoryFields.showImage },
          "AnswerQuestionsAPI/AnswersFileDelete"
        );
        toast.success("Document Repository deleted successfully 🗑️", {
          duration: 5000,
          position: "top-center",
        });
        cancel();
      } else {
        toast.error("Document Repository action failed 👎", {
          duration: 2000,
          position: "top-center",
        });
        setTimeout(cancel, 2000);
      }
    }
  };
  const cancel = () => {
    setFileName("");
    setFilePopUpOpen(false);
    setPopUpSubmit(0);
    setShowLogoutModal(false);
    setRowIndex(null);
    setNoOfReferences(0);
    setVisibleTable(true);
    setVisibleAdd(false);
    setDocumentRepositoryId("");
    setIsLoading(true);
    setDocumentRepositoryFields({
      date: new Date().toISOString().split("T")[0],
      paymentMethod: "",
      documentName: "",
      bank: "",
      bankBranch: "",
      amount: "",
      referenceNumber: "",
      showImage: null,
      ImageSize: "",
    });
    setDocumentRepositoryFieldsError({
      dateError: "",
      paymentMethodError: "",
      documentNameError: "",
      bankError: "",
      bankBranchError: "",
      amountError: "",
      referenceNumberError: "",
      showImageError: null,
    });
    setSubmitBtnDisabled(false);
    bindDocumentRepository();
    setpopUpOpen(false);
    setIsLoading(false);
  };

  // const handleShowImage = (showImage) => {
  //   
  //   if (!showImage || !showImage.fileUrl) {
  //     return;
  //   }

  //   const fileName = showImage.fileUrl.split("/").pop();

  //   const cleanFileName = decodeURIComponent(fileName);

  //   console.log(cleanFileName);

  //   const isDuplicate = bindDocumentRepositoryData.some(
  //     (item) => item.Attachment === showImage.fileUrl
  //   );

  //   if (isDuplicate) {
  //     // Show error message if duplicate
  //     setDocumentRepositoryFieldsError({
  //       ...documentRepositoryFieldsError,
  //       showImageError: `File name "${cleanFileName}" already exists. Rename and try again.`,
  //     });
  //     setDocumentRepositoryFields({
  //       ...documentRepositoryFields,
  //       showImage: "", // This will set to showImage if it's truthy, else ""
  //     });

  //     setFileClear(true);
  //   } else {
  //     setDocumentRepositoryFields({
  //       ...documentRepositoryFields,
  //       showImage: showImage.fileUrl || "", // This will set to showImage if it's truthy, else ""
  //       ImageSize: showImage.fileSizeInKB || "",
  //     });
  //   }
  // };


const handleShowImage = (showImage) => {
  

  // If showImage or showImage.fileUrl is falsy, just set the fields and return
  if (!showImage || !showImage.fileUrl) {
    setDocumentRepositoryFields({
      ...documentRepositoryFields,
      showImage: showImage?.fileUrl || "",
      ImageSize: showImage?.fileSizeInKB || "",
    });
    return;
  }

  // Extract file name
  const fileName = showImage.fileUrl.split("/").pop();
  const cleanFileName = decodeURIComponent(fileName);
  console.log(cleanFileName);

  // Check for duplicate
  const isDuplicate = bindDocumentRepositoryData.some(
    (item) => item.Attachment === showImage.fileUrl
  );

  if (isDuplicate) {
    // Show error message if duplicate
    setDocumentRepositoryFieldsError({
      ...documentRepositoryFieldsError,
      showImageError: `File name "${cleanFileName}" already exists. Rename and try again.`,
    });

    // Clear the showImage field
    setDocumentRepositoryFields({
      ...documentRepositoryFields,
      showImage: "",
    });

    setFileClear(true);
  } else {
    // Set the new image fields
    setDocumentRepositoryFields({
      ...documentRepositoryFields,
      showImage: showImage.fileUrl,
      ImageSize: showImage.fileSizeInKB || "",
    });
  }
};



  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true); // Add Screen title & button
    setUpdateScreenTitle(false); // Update Screen title & button
  };

  const handleDocumentRepository = (rowIndex, flag) => {
    setShowLogoutModal(true);
    setRowIndex(rowIndex);

    setNoOfReferences(bindDocumentRepositoryData[rowIndex].NoOfReferences);
    setDocumentRepositoryId(
      bindDocumentRepositoryData[rowIndex].DocumentRepositoryId
    );
    setDocumentRepositoryFields({
      showImage: bindDocumentRepositoryData[rowIndex].Attachment,
    });
    setViewDetails(true);
    const rowData = bindDocumentRepositoryData[rowIndex];
    setDocumentRepositoryData(rowData);
  };

  const handleViewFile = (rowIndex, flag) => {
    setFilePopUpOpen(true);
    setHeaderDetails(true);
    const rowData = bindDocumentRepositoryData[rowIndex].Attachment;
    setFileName(bindDocumentRepositoryData[rowIndex].FileName);
    setFilePopUp(rowData);
  };

  const handleNoOfReferences = (rowIndex) => {
    const rowData = bindDocumentRepositoryData[rowIndex].Attachment;
    const NoOfReferences = bindDocumentRepositoryData[rowIndex].NoOfReferences;

    if (NoOfReferences != 0) {
      setNoOfReferencesPopUpOpen(true);
      setHeaderDetails(true);
      const matchingDocuments = documentRepositoryPopupData.filter(
        (item) => item.AttachedDocument === rowData
      );

      if (matchingDocuments.length > 0) {
        setNoOfReferencesDatas(matchingDocuments); // or use `matchingDocuments` if you want all
      } else {
        setNoOfReferencesDatas([]);
      }
    } else {
      toast.error("No References", {
        duration: 5000,
        position: "top-center",
      });
    }
  };

  const popUpsubmit = (value) => {
    if (value == 1) {
      setPopUpSubmit(value);
      setpopUpOpen(false);
      setShowLogoutModal(true);
    } else {
      cancel();
    }
  };

  return (
    <MainLayout pageName={"4"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && !isLoading && (
        <GridPage
          title="Document Repository"
          header={documentRepositoryHeader}
          records={bindDocumentRepositoryData}
          blockView={true}
          handleAction={handleDocumentRepository}
          onViewFile={handleViewFile}
          showAdd={showAdd}
          onNoOfReferences={handleNoOfReferences}
        />
      )}
      {visibleAdd && (
        <div class=" flex flex-col w-full">
          <div class={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Document Repository"
            />

            <div class={mainTable.addShadowScreen}>
              <div class={mainTable.mainContentScreen}>
                <form class={mainTable.formForClientMaster}>
                  <div className=" gap-4 sm:flex">
                    <div className="sm:w-1/4">
                      <InputText
                        inputType="text"
                        title="Document Name"
                        name="documentName"
                        content={documentRepositoryFields.documentName}
                        maxLength={100}
                        classStar="text-red-500"
                        controlFunc={(e) => {
                          setDocumentRepositoryFields({
                            ...documentRepositoryFields,
                            documentName: e.target.value,
                          });
                        }}
                        controlFuncBlur={() => {
                          const trimmeddocumentName =
                            documentRepositoryFields.documentName?.trim() || "";
                          setDocumentRepositoryFieldsError(() => ({
                            ...documentRepositoryFieldsError,
                            documentNameError: trimmeddocumentName
                              ? ""
                              : "Enter Document Name",
                          }));
                        }}
                        errorMessage={
                          documentRepositoryFieldsError.documentNameError
                        }
                      />
                    </div>

                    <div className="sm:w-3/4">
                      <FileUpload
                        title="file"
                        apiCall="DocumentRepositoryAPI/DocumentRepositoryFileUpload"
                        modalName="DocumentRepositoryUpload"
                        partnerId={partnerId}
                        clear={fileClear}
                        name="showImage"
                        classStar="text-red-500"
                        showImage={documentRepositoryFields.showImage}
                        showImageData={handleShowImage}
                        imageUploadedError={
                          documentRepositoryFieldsError.showImageError
                        }
                        clearImageUploadError={() =>
                          setDocumentRepositoryFieldsError((prev) => ({
                            ...prev,
                            showImageError: "",
                          }))
                        }
                        limitMassage={`Attachment file size limit: ${imageSize} MB. Accepted file types are PDF, XLS, XLSX, DOC, DOCX, PPT, PPTX, JPG, JPEG, PNG.
                                                Please Upload The File After Choosing It.`}
                        imageShow={false}
                        MAX_FILE_SIZE_MB={100}
                        ALLOWED_FORMATS={[
                          "image/jpeg",
                          "image/jpg",
                          "image/png",
                          "application/pdf", // for PDFs
                          "application/msword", // for .doc files
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
                          "application/vnd.ms-excel", // for .xls files (older Excel format)
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
                          "application/vnd.ms-powerpoint", // for .ppt files
                          "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
                        ]}
                      />
                    </div>
                  </div>
                </form>

                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled ? true : false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="Document Repository"
            setpopUpOpen={setpopUpOpen}
            deleteDetails={viewDetails}
          />

          <DocumentRepositoryPopup
            data={documentRepositoryData}
            submitData={(value) => {
              popUpsubmit(value);
            }}
            isLoading={isLoading}
          />
        </div>
      </MainPopup>

      <MainPopup
        popUpOpen={noOfReferencesPopUpOpen}
        setpopUpOpen={setNoOfReferencesPopUpOpen}
        Open={() => setNoOfReferencesPopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title="No Of References"
            setpopUpOpen={setNoOfReferencesPopUpOpen}
            hederDetails={headerDetails}
          />

          <NoOfReferencesPopup
            data={noOfReferencesDatas}
            isLoading={isLoading}
          />
        </div>
      </MainPopup>

      <MainPopup
        popUpOpen={filePopUpOpen}
        setpopUpOpen={setFilePopUpOpen}
        Open={() => setFilePopUpOpen(true)}
      >
        <div>
          <PopUpScreenTitle
            title={`File Name - ${fileName}`}
            setpopUpOpen={setFilePopUpOpen}
            hederDetails={headerDetails}
          />

          <DocumentRepositroyFilePopup data={filePopUp} isLoading={isLoading} />
        </div>
      </MainPopup>

      {showLogoutModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
          onClick={() => setShowLogoutModal(false)} // Close on backdrop click
        >
          <div
            className="bg-white rounded-lg p-8 shadow-xl w-[90%] max-w-xl" // Larger size
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            <h2 className="text-2xl font-bold mb-4">Confirm Delete</h2>
            <p className="text-lg mb-6">
              {noOfReferences === 0
                ? "Are You Sure To Delete This Document"
                : `Are You Sure To Delete This Document As It Has ${noOfReferences} Reference${
                    noOfReferences > 1 ? "s" : ""
                  }`}
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => {
                  if (popUpSubmit == 1) {
                    handleSubmit(rowIndex, 3);
                  } else {
                    setpopUpOpen(true);
                  }
                }}
                className="px-6 py-2 bg-gray-800 text-white rounded hover:bg-gray-900 text-lg"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setShowLogoutModal(false);
                  cancel();
                }}
                className="px-6 py-2 bg-gray-300 rounded hover:bg-gray-400 text-lg"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default DocumentRepository;
